const PARAMS_KEY = "cc.p";

export function trackOfflineSource(
  source: "phone" | "whatsapp",
  placement: string,
) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const existing = JSON.parse(localStorage.getItem(PARAMS_KEY) || "{}");
    localStorage.setItem(
      PARAMS_KEY,
      JSON.stringify({
        ...existing,
        source,
        source_placement: placement,
      }),
    );
  } catch {
    // Ignore storage failures.
  }
}
